/**
 * The current instant, kept fresh for time-dependent views (PB-14).
 *
 * The order's progress turns on time — a start passing, a payment deadline
 * running out — and a page left open showed the old step until something
 * else re-rendered it. Ticks once a minute, and at once when the window or
 * tab comes back, which is when an admin is actually looking again.
 */
import { useEffect, useState } from 'react';

export function useNow(intervalMs = 60_000): string {
  const [now, setNow] = useState(() => new Date().toISOString());
  useEffect(() => {
    const tick = () => setNow(new Date().toISOString());
    const id = window.setInterval(tick, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === 'visible') tick();
    };
    window.addEventListener('focus', tick);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(id);
      window.removeEventListener('focus', tick);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);
  return now;
}
